import Reflux from 'reflux';
import { AppActions, SettingsActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import deepExtend from 'deep-extend';

const SettingsStore = Reflux.createStore({
  listenables: [SettingsActions],
  data: {
    list: {},
    saving: false,
    frontend: {},
    loading: true
  },
  getInitialState() {
    return this.data;
  },
  onRead() {
    return SteelCompass.call('settings', 'read', {}, response => {
      this.data.loading = true;
      this.trigger(this.data);
      SettingsActions.readComplete(response.data);
    });
  },
  onReadComplete(data) {
    this.data = {
      list: {
        ...data,
        js: (data && data.js) || {},
        features: (data && data.features) || {}
      },
      frontend: (data && data.js) || {},
      loading: false
    };
    this.trigger(this.data);
  },
  update(settings) {
    this.data = {
      ...this.data,
      saving: true
    };
    this.trigger(this.data);
    return SteelCompass.request('settings', 'update', settings).then(
      () => {
        SettingsActions.updateComplete(settings);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  updateComplete(settings) {
    this.data = {
      ...this.data,
      saving: false
    };
    const user = JSON.parse(localStorage.getItem('user'));
    const newUser = { ...user, features: settings.features };
    localStorage.setItem('user', JSON.stringify(newUser));
    this.trigger(this.data);
    AppActions.translatableMessage('settings.saved');
  },
  saveFrontend(settings) {
    const newSettings = Object.assign({}, this.data.frontend);
    deepExtend(newSettings, settings);
    return SteelCompass.request('settings', 'update', { js: newSettings }).then(
      response => {
        SettingsActions.saveFrontendComplete(newSettings);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  saveFrontendComplete(settings) {
    this.data = {
      list: {
        ...this.data.list,
        js: {
          ...settings
        }
      },
      frontend: {
        ...settings
      }
    };
    this.trigger(this.data);
  }
});

export default SettingsStore;



// WEBPACK FOOTER //
// ./src/js/stores/Settings.js